(function () {
  'use strict';

  if (window.__boiProductGalleryRegistered) return;
  window.__boiProductGalleryRegistered = true;

  var viewerPromise;
  var finePointer = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');

  window.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-boi-gallery-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    trigger.dispatchEvent(new CustomEvent('boi:gallery-open'));
  }, true);

  function loadAsset(type, url, marker) {
    var existing = document.querySelector('[' + marker + ']');
    if (existing) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var node = document.createElement(type === 'script' ? 'script' : 'link');
      if (type === 'script') {
        node.src = url;
        node.async = true;
      } else {
        node.rel = 'stylesheet';
        node.href = url;
      }
      node.setAttribute(marker, '');
      node.onload = resolve;
      node.onerror = reject;
      document.head.appendChild(node);
    });
  }

  window.BoiLoadProductGalleryViewer = window.BoiLoadProductGalleryViewer || function (gallery) {
    if (window.BoiProductGalleryViewer) return Promise.resolve(window.BoiProductGalleryViewer);
    if (viewerPromise) return viewerPromise;
    viewerPromise = loadAsset('style', gallery.dataset.boiGalleryViewerStyle, 'data-boi-gallery-viewer-style-loaded')
      .then(function () { return loadAsset('script', gallery.dataset.boiGalleryViewerScript, 'data-boi-gallery-viewer-script-loaded'); })
      .then(function () {
        if (!window.BoiProductGalleryViewer) throw new Error('Native product viewer failed to initialize');
        return window.BoiProductGalleryViewer;
      })
      .catch(function (error) {
        viewerPromise = null;
        throw error;
      });
    return viewerPromise;
  };

  function initGallery(gallery) {
    if (gallery.dataset.boiGalleryReady === 'true') return;
    gallery.dataset.boiGalleryReady = 'true';

    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-boi-gallery-item]'));
    var main = gallery.querySelector('[data-boi-gallery-main]');
    var image = gallery.querySelector('[data-boi-gallery-image]');
    var openButton = gallery.querySelector('[data-boi-gallery-open]');
    var dynamic = gallery.querySelector('[data-boi-gallery-dynamic]');
    var stage = gallery.querySelector('[data-boi-gallery-stage]');
    var previous = gallery.querySelector('[data-boi-gallery-prev]');
    var next = gallery.querySelector('[data-boi-gallery-next]');
    var lens = gallery.querySelector('[data-boi-gallery-lens]');
    var zoomPane = gallery.querySelector('[data-boi-gallery-zoom-pane]');
    var current = Math.max(0, items.findIndex(function (item) { return item.getAttribute('aria-current') === 'true'; }));
    var touchStart = null;
    var zoomImage = null;
    var zoomUrl = '';
    var zoomRaf = 0;

    if (!items.length || !main || !image || !stage) return;
    gallery.classList.add('is-ready');
    if (openButton) main.tabIndex = -1;

    function stopMedia() {
      if (!dynamic) return;
      Array.prototype.forEach.call(dynamic.querySelectorAll('video'), function (video) { video.pause(); });
      dynamic.replaceChildren();
    }

    function itemAt(index) {
      return items[(index + items.length) % items.length];
    }

    function clearZoom() {
      gallery.classList.remove('is-zooming', 'is-zoom-inside');
      if (zoomPane) zoomPane.style.backgroundImage = '';
      zoomImage = null;
      zoomUrl = '';
    }

    function showMedia(item, index, focus) {
      if (!item) return;
      var type = item.dataset.boiMediaType;
      var mediaId = item.dataset.boiMediaId;
      current = index;
      gallery.dataset.boiGalleryIndex = String(index);
      clearZoom();
      items.forEach(function (candidate, candidateIndex) {
        var active = candidateIndex === index;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-current', active ? 'true' : 'false');
      });

      stopMedia();
      if (type === 'image') {
        main.hidden = false;
        if (dynamic) dynamic.hidden = true;
        main.href = item.dataset.boiMediaFull;
        image.src = item.dataset.boiMediaSrc;
        image.srcset = item.dataset.boiMediaSrcset;
        image.sizes = item.dataset.boiMediaSizes;
        image.width = Number(item.dataset.boiMediaWidth) || image.width;
        image.height = Number(item.dataset.boiMediaHeight) || image.height;
        image.alt = item.dataset.boiMediaAlt || '';
        image.id = 'product-featured-image-' + mediaId;
      } else {
        main.hidden = true;
        if (dynamic) {
          var template = gallery.querySelector('template[data-boi-gallery-template="' + mediaId + '"]');
          if (template) dynamic.appendChild(template.content.cloneNode(true));
          dynamic.hidden = false;
        }
      }
      if (focus && !item.hidden) item.focus({ preventScroll: true });
    }

    function move(step, focus) {
      showMedia(itemAt(current + step), (current + step + items.length) % items.length, focus);
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () { showMedia(item, index, false); });
    });
    if (previous) previous.addEventListener('click', function () { move(-1, false); });
    if (next) next.addEventListener('click', function () { move(1, false); });

    gallery.tabIndex = 0;
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1, true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1, true);
      }
    });
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (!touchStart || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - touchStart.x;
      var dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy) * 1.25) move(dx > 0 ? -1 : 1, false);
    }, { passive: true });

    function positionZoom(event) {
      if (!zoomImage || !zoomPane || !lens) return;
      var rect = image.getBoundingClientRect();
      var x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      var y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
      var px = x / rect.width;
      var py = y / rect.height;
      cancelAnimationFrame(zoomRaf);
      zoomRaf = requestAnimationFrame(function () {
        lens.style.left = (px * 100) + '%';
        lens.style.top = (py * 100) + '%';
        zoomPane.style.backgroundPosition = (px * 100) + '% ' + (py * 100) + '%';
      });
    }

    function prepareZoom(event) {
      var item = items[current];
      if (!finePointer.matches || gallery.dataset.boiGalleryZoomEnabled !== 'true' || item.dataset.boiMediaType !== 'image') return;
      var url = item.dataset.boiMediaZoom;
      if (!url) return;
      if (zoomUrl !== url) {
        zoomUrl = url;
        zoomImage = new Image();
        zoomImage.onload = function () {
          if (!zoomPane) return;
          zoomPane.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
          var room = window.innerWidth - stage.getBoundingClientRect().right;
          gallery.classList.toggle('is-zoom-inside', room < 360);
          gallery.classList.add('is-zooming');
          positionZoom(event);
        };
        zoomImage.src = url;
      } else if (zoomImage.complete) {
        gallery.classList.add('is-zooming');
        positionZoom(event);
      }
    }

    stage.addEventListener('pointerenter', prepareZoom);
    stage.addEventListener('pointermove', function (event) {
      if (gallery.classList.contains('is-zooming')) positionZoom(event);
    });
    stage.addEventListener('pointerleave', function () { gallery.classList.remove('is-zooming'); });
    (openButton || main).addEventListener('focus', function () {
      if (!finePointer.matches) return;
      var rect = image.getBoundingClientRect();
      prepareZoom({ clientX: rect.left + rect.width / 2, clientY: rect.top + rect.height / 2 });
    });
    (openButton || main).addEventListener('blur', function () { gallery.classList.remove('is-zooming'); });

    (openButton || main).addEventListener(openButton ? 'boi:gallery-open' : 'click', function (event) {
      if (gallery.dataset.boiGalleryZoomEnabled !== 'true') return;
      event.preventDefault();
      gallery.classList.add('boi-media-loading');
      gallery.setAttribute('aria-busy', 'true');
      window.BoiLoadProductGalleryViewer(gallery).then(function (viewer) {
        viewer.open(gallery, current, openButton || main);
      }).catch(function () {
        gallery.classList.add('is-viewer-failed');
        window.location.assign(main.href);
      }).finally(function () {
        gallery.classList.remove('boi-media-loading');
        gallery.setAttribute('aria-busy', 'false');
      });
    });

    function selectVariantMedia() {
      var configNode = document.getElementById('boi-product-config');
      var variantSelect = document.getElementById('productSelect');
      if (!configNode || !variantSelect) return;
      try {
        var productConfig = JSON.parse(configNode.textContent).product;
        var variant = productConfig.variants.find(function (candidate) { return String(candidate.id) === String(variantSelect.value); });
        var mediaId = variant && variant.featured_image && variant.featured_image.id;
        var index = items.findIndex(function (item) { return String(item.dataset.boiMediaId) === String(mediaId); });
        if (index >= 0) showMedia(items[index], index, false);
      } catch (error) {}
    }
    document.addEventListener('change', function (event) {
      if (event.target.closest('.product-single')) window.setTimeout(selectVariantMedia, 0);
    });
    document.addEventListener('boi:variant-change', selectVariantMedia);

    gallery.dataset.boiGalleryIndex = String(current);
    if (items[current].dataset.boiMediaType !== 'image') {
      showMedia(items[current], current, false);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-boi-product-gallery]'), initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
